const BorderAddComponent = ({
  children,
  borderColor,
  shouldAnimate,
  showBorder,
}) => {
  return (
    <div
      style={{
        border: showBorder
          ? `var(--border) solid var(--${borderColor}) `
          : "var(--border) solid transparent",
      }}
      className={`${shouldAnimate && "animated-border"} rounded-border-radius-sm `}
    >
      {children}
    </div>
  );
};

export default BorderAddComponent;
